import { AxiosInstance } from "axios"
import { GenericResponse } from "."

export interface SuiteModel {
    total: number
    suites: []
    page: number
    page_size: number
}

export interface SuiteListRequest {
    from: string
    to: string
}
export interface paginationData {
    page?: number
    pageSize?: number
    search?: string
    warehouse?: string
    status?: string
}

const suiteApi = (apiInstance: AxiosInstance) => {
    const suitesList = async (data: paginationData): Promise<GenericResponse> => {
        var status = ""
        if (data.status === "Busy") status = "1"
        else if (data.status === "Free") status = "0"
        var params = data.page ? "page=" + data.page : ""
        params += data.pageSize ? "&page_size=" + data.pageSize : ""
        params += data.search ? "&suite=" + data.search : ""
        params += data.status ? "&status=" + status : ""
        params += data.warehouse ? "&warehouse=" + data.warehouse : ""
        var url = "/suites/get-suites"
        url = params ? url + "?" + params : ""
        const res: Promise<GenericResponse> = apiInstance.get(url)
        return res
    }

    return {
        suitesList
    }
}

export default suiteApi
